import {useSelector} from "react-redux";
import {useState} from "react";
import {SingleCampaign} from "./SingleCampaign";
import {CampaignGrid} from "../components/campaigns/CampaignGrid";
import CampaignBuilderModal from "../components/modals/CampaignBuilderModal";
import {useIsAdmin} from "../hooks/useIsAdmin";

const Campaigns = () => {
    const campaigns = useSelector((state) => state.organisation?.currentOrganisation?.campaigns);
    const [currentCampaign, setCurrentCampaign] = useState(null);
    const [showCampaignBuilder, setShowCampaignBuilder] = useState(false);
    const isAdmin = useIsAdmin();

    const onCampaignClick = (campaign) => {
        setCurrentCampaign(campaign);
    }

    const onCampaignClose = () => {
        setCurrentCampaign(null);
    }

    return (
        <div className="main-section">
            {currentCampaign ? (
                <SingleCampaign campaign={currentCampaign} onClose={onCampaignClose}/>
            ) : (
                <>
                    <CampaignGrid
                        onCampaignClick={onCampaignClick}
                        campaigns={campaigns}
                        onCreateCampaign={() => setShowCampaignBuilder(true)}
                        isAdmin={isAdmin}
                    />
                    {isAdmin && showCampaignBuilder && (
                        <CampaignBuilderModal
                            closeModal={() => setShowCampaignBuilder(false)}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default Campaigns;
